<template>
  <img
    v-if="props.logo !== ''"
    :src="props.logo"
    :class="props.xl ? 'h-[80px]' : 'h-[40px]'"
    class="object-contain"
  />
</template>

<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  logo: any;
  xl?: boolean;
}>();
</script>
